import * as Yup from 'yup';
import t from 'react-translate';
import { useMediaQuery } from 'react-responsive';
import { screenSmMax, screenXsMax } from 'styles/global_defaults/media-queries';
import { doubleSpacing, shortBar, standardSpacing } from 'styles/global_defaults/scaffolding';

const useAiRolePlayHelper = () => {
  const aiInstructionsValidationSchema = {
    learnerRole: Yup.string().required(t.VALIDATION.REQUIRED()).max(255, t.VALIDATION.MAX_LENGTH('255')),
    aiCharacterRole: Yup.string().required(t.VALIDATION.REQUIRED()).max(255, t.VALIDATION.MAX_LENGTH('255')),
    aiCharacterName: Yup.string().required(t.VALIDATION.REQUIRED()).max(255, t.VALIDATION.MAX_LENGTH('255')),
    context: Yup.string().required(t.VALIDATION.REQUIRED()).max(10000, t.VALIDATION.MAX_LENGTH('10000')),
    aiCharacterPersonality: Yup.string().required(t.VALIDATION.REQUIRED()),
    requiredAiLearnerGoal: Yup.object().shape({
      text: Yup.string().required(t.VALIDATION.REQUIRED()),
    }),
    aiCharacterObjections: Yup.array()
      .of(
        Yup.object().shape({
          text: Yup.string(),
        }),
      ),
    aiLearnerGoals: Yup.array()
      .of(
        Yup.object().shape({
          text: Yup.string(),
        }),
      ),
  };

  const basicsValidationSchema = {
    title: Yup.string(),
    description: Yup.string(),
    contextDescription: Yup.string(),
  };

  const createAiRolePlayValidationSchema = Yup.object().shape({
    ...basicsValidationSchema,
    ...aiInstructionsValidationSchema,
  });

  const updateAiRolePlayValidationSchema = Yup.object().shape({
    ...aiInstructionsValidationSchema,
  });

  const isMobile = useMediaQuery({
    query: `(max-width: ${screenXsMax}px)`,
  });
  const isTabletOrSmaller = useMediaQuery({
    query: `(max-width: ${screenSmMax}px)`,
  });

  const getResponsivePadding = (isBodyPartitioned) => {
    if (isMobile || isBodyPartitioned) {
      return standardSpacing;
    }
    if (isTabletOrSmaller) {
      return doubleSpacing;
    }
    return shortBar;
  };

  return {
    createAiRolePlayValidationSchema,
    updateAiRolePlayValidationSchema,
    getResponsivePadding,
    isMobile,
    isTabletOrSmaller,
  };
};

export default useAiRolePlayHelper;
